// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__+EtLR","tyre":"style_tyre__68wz3"};